import { createSlice } from "@reduxjs/toolkit";
import {
  getNotifications,
  getNotificationDetail,
  getUnreadNotificationCount,
  markAllNotificationsRead,
} from "../actions/notification";

const states = {
  data: null,
  pagination: {
    current_page: 1,
    total_pages: 1,
  },
  notification: {
    loading: false,
    error: false,
    data: null,
  },
  unreadCount: 0,
  loading: false,
  error: false,
};

export const notificaions = createSlice({
  initialState: states,
  name: "notifications",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNotifications.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(getNotifications.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      state.data = action.payload.data;
      state.pagination = {
        current_page: action.payload.data?.data?.current_page,
        total_pages: action.payload.data?.data?.last_page,
      };
    });
    builder.addCase(getNotifications.rejected, (state, action) => {
      state.error = true;
      state.loading = false;
    });
    builder.addCase(getNotificationDetail.pending, (state, action) => {
      state.notification.error = false;
      state.notification.loading = true;
    });
    builder.addCase(getNotificationDetail.fulfilled, (state, action) => {
      state.notification.error = false;
      state.notification.loading = false;
      state.notification.data = action.payload.data.data;
      // Decrement unread count when a notification is read
      if (state.unreadCount > 0) {
        state.unreadCount = state.unreadCount - 1;
      }
    });
    builder.addCase(getNotificationDetail.rejected, (state, action) => {
      state.notification.error = false;
      state.notification.loading = false;
    });
    // Unread count
    builder.addCase(getUnreadNotificationCount.fulfilled, (state, action) => {
      state.unreadCount = action.payload?.data?.data?.unread_count || 0;
    });
    builder.addCase(markAllNotificationsRead.fulfilled, (state, action) => {
      state.unreadCount = 0;
    });
  },
});

export default notificaions.reducer;
